export default {
    methods: {
        getSessionsByDifficultyId(difficultyId) {
            return this.get(`/difficulty/${difficultyId}/sessions`);
        },

        getSession(sessionId) {
            return this.get(`/session/${sessionId}`);
        },
    }
}